/**
 * Use Cases dropdown nav items.
 *
 * Kept in a separate file from `USE_CASES` (which carries the full
 * landing-page content — `headline`, `subTopics`, …) so the client bundle
 * for `HomepageHeader` only ships these 6 `{name, slug}` pairs. JS object
 * literals can't be tree-shaken field-by-field, so importing `USE_CASES`
 * into a client component pulls every `subTopics[].solutionPoints` string
 * into the browser bundle on every public route.
 *
 * Slugs must match the canonical `slug` field in `data.ts`. Drift is
 * checked by `nav.test.ts`, runnable via `pnpm --filter b3os-web run test`.
 * Note: vitest is not yet wired into the b3os-web GitHub Actions workflow
 * (only b3os-actions and anyspend-service run vitest in CI today), so this
 * check is local-only — run it before merging changes here.
 *
 * "Alert & Monitoring" is a deliberate display-name override; the data
 * source uses "Alert Monitoring". Sorted alphabetically.
 */
export const USE_CASE_NAV_ITEMS: ReadonlyArray<{ name: string; slug: string }> = [
  { name: "Alert & Monitoring", slug: "onchain-alert-monitoring-automation" },
  { name: "Crypto Accounting", slug: "automated-crypto-accounting-workflows" },
  { name: "Developer Tooling", slug: "blockchain-developer-tooling-automation" },
  { name: "Portfolio Rebalancing", slug: "automated-portfolio-rebalancing-crypto" },
  { name: "Stablecoin Operations", slug: "stablecoin-operations-automation" },
  { name: "Trading Automation", slug: "automated-crypto-trading-workflows" },
];
